import { gettext } from '@eventbrite/i18n';
import classNames from 'classnames';
import React from 'react';
import { numberFormatter } from '../../utils/utils';
import './OrganizerStats.scss';

export enum StyleTypes {
    CONDENSED = 'condensed',
    CONDENSED_FULL_WIDTH = 'condensed-full-width',
    EXPANDED = 'expanded',
}

type OrganizerStatsProps = {
    displayRating?: boolean;
    followersCount: number | null;
    organizer: {
        id: string;
    };
    style?: StyleTypes;
};

const FOLLOWERS_THRESHOLD = 9;

export const OrganizerStats = ({
    displayRating = false,
    followersCount,
    style = StyleTypes.CONDENSED,
}: OrganizerStatsProps) => {
    const shouldShowNumberFollowers =
        followersCount && followersCount > FOLLOWERS_THRESHOLD;

    if (!displayRating && !shouldShowNumberFollowers) {
        return null;
    }

    const classes = classNames(
        'organizer-stats',
        { 'organizer-stats--expanded': style === StyleTypes.EXPANDED },
        { 'organizer-stats--condensed': style === StyleTypes.CONDENSED },
        {
            'organizer-stats--condensed-full-width':
                style === StyleTypes.CONDENSED_FULL_WIDTH,
        },
    );

    return (
        <div className={classes}>
            {shouldShowNumberFollowers && (
                <div data-testid="followers-count">
                    <span className="organizer-stats__highlight">
                        {numberFormatter(followersCount)}
                    </span>{' '}
                    <span className="organizer-stats__suffix">
                        {/* Translators: This string is preceded by the {number_of_followers} Ex. 320 followers */}
                        {gettext('followers')}
                    </span>
                </div>
            )}
        </div>
    );
};
